import { useEffect } from "react";

const useSmoothScroll = () => {
	const handleHashChange = (e) => {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		const { hash } = window.location;
		if (hash) {
			const id = hash.replace("#", "");
			const element = document.getElementById(id);
			if (element) {
				setTimeout(() => {
					element.scrollIntoView({
						behavior: "smooth",
						block: "start",
					});
				}, 500);
			}
		}
		return false;
	};

	useEffect(() => {
		window.addEventListener("hashchange", handleHashChange);
		window.addEventListener("load", handleHashChange);
		handleHashChange();
		return () => {
			window.removeEventListener("hashchange", handleHashChange);
			window.removeEventListener("load", handleHashChange);
		};
	}, []);
};

export default useSmoothScroll;
